import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ems/ui/components/card'

import { usageQuery } from '#admin/features/platform/usage/api.ts'
import { QuotaMeters } from '#admin/features/platform/usage/quota-meter.tsx'
import { TenantUsageSkeleton } from '#admin/features/platform/platform-skeletons.tsx'

/** `/platform/tenants/$tenantId/usage` — this edition against its plan's quotas. */
export const Route = createFileRoute('/_authenticated/platform/tenants/$tenantId/usage')({
  pendingComponent: TenantUsageSkeleton,
  staticData: { crumb: 'Usage' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(usageQuery(params.tenantId)),
  component: UsageTab,
})

function UsageTab() {
  const { tenantId } = Route.useParams()
  const { data } = useSuspenseQuery(usageQuery(tenantId))
  const row = data.items[0]
  if (row === undefined) return null

  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <Card>
        <CardHeader>
          <CardTitle>Quotas</CardTitle>
          <CardDescription>Against the {row.planName} plan, counted live.</CardDescription>
        </CardHeader>
        <CardContent>
          <QuotaMeters row={row} />
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Also counted</CardTitle>
          <CardDescription>Not quotas, but what the edition holds.</CardDescription>
        </CardHeader>
        <CardContent>
          <dl className="grid grid-cols-[1fr_auto] gap-y-2 text-sm">
            <dt className="text-muted-foreground">Companies</dt>
            <dd className="tabular-nums">{row.companies.toLocaleString()}</dd>
            <dt className="text-muted-foreground">Delegate profiles</dt>
            <dd className="tabular-nums">{row.eventProfiles.toLocaleString()}</dd>
            <dt className="text-muted-foreground">Messages waiting to be sent</dt>
            <dd className="tabular-nums">{row.outboxPending.toLocaleString()}</dd>
          </dl>
        </CardContent>
      </Card>
    </div>
  )
}
